import { ReactElement } from 'react';

import { Navigate } from 'react-router-dom';

import {
    getCurrentAppData,
    useApplicationStore,
} from '@App/stores/applicationStore';

interface ProtectedRouteProps {
    isPrevStepComplete?: boolean;
    prevStepRedirectTo?: string;
    isStepComplete?: boolean;
    stepCompleteRedirectTo?: string;
    expectedDecisionStatus?: 'approved' | 'declined' | 'existing-loan';
    decisionRedirectTo?: string;
    children: ReactElement;
}

const ProtectedRoute = ({
    isPrevStepComplete,
    prevStepRedirectTo,
    isStepComplete,
    stepCompleteRedirectTo,
    expectedDecisionStatus,
    decisionRedirectTo,
    children,
}: ProtectedRouteProps) => {
    const decisionStatus = useApplicationStore(
        (state) => getCurrentAppData(state).decisionStatus,
    );

    const currentStep = useApplicationStore(
        (state) => getCurrentAppData(state).currentStep,
    );

    if (expectedDecisionStatus) {
        if (decisionStatus !== expectedDecisionStatus) {
            if (decisionRedirectTo) {
                return <Navigate to={decisionRedirectTo} replace />;
            }
            return null;
        }
        return children;
    }

    if (decisionStatus === 'declined') {
        const step = currentStep ?? 'unknown';
        return <Navigate to={`/declined?currentStep=${step}`} replace />;
    }

    if (decisionStatus === 'approved') {
        return <Navigate to='/approved' replace />;
    }

    if (decisionStatus === 'existing-loan') {
        return <Navigate to='/existing-loan' replace />;
    }

    if (isPrevStepComplete === false) {
        if (prevStepRedirectTo) {
            return <Navigate to={prevStepRedirectTo} replace />;
        }
        return null;
    }

    if (isStepComplete && stepCompleteRedirectTo) {
        return <Navigate to={stepCompleteRedirectTo} replace />;
    }

    return children;
};

export default ProtectedRoute;
